/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterContentChecked,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { SchemaField, Document, TextFieldFormat, DocumentSchema, SystemFieldType } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { TranslateService } from '@ngx-translate/core';
import { ViewComponent } from '../../../store/models/workflow.model';
import { DocumentReader } from 'src/app/modules/core/store/models';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuillEditorService } from '../../../services/quill/quill.service';
import { UserPreferencesFacade } from '@app/core/stores/user-preferences';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss'],
  standalone: false
})
export class TextFieldComponent implements AfterContentChecked, DynamicField, OnDestroy {
  @ViewChild('multilineReadonly') multilineReadonly: ElementRef;

  hasEditorBeenInitialized: boolean;
  valueForDisplay: string;
  showFieldAsEdit: boolean = false;
  fieldUId: string;
  _value: string;
  format: string;
  isReadOnly = false;
  isOverflow = false;
  TextFieldFormat = TextFieldFormat;
  showMultilineTextDialog = false;
  isScrolled = false;
  controlHeight = 32;
  _field: SchemaField;
  reader: DocumentReader;
  destroy$ = new Subject<void>();
  editor: any;

  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() set field(value: SchemaField) {
    this._field = value;
    this.fieldUId = value.uId;
    this.format = value?.settings?.format === TextFieldFormat.MultiLine ? TextFieldFormat.MultiLine : TextFieldFormat.SingleLine;
  }
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() viewComponent: ViewComponent;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;

  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  get document(): Document {
    return this.reader.document;
  }

  get field(): SchemaField {
    return this._field;
  }

  set value(val: string) {
    if (!val) {
      val = '';
    }
    this.valueForDisplay = val || '---';

    this._value = val;

    this.changeDetector.detectChanges();
  }
  get value(): string {
    return this._value;
  }

  _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  get editorModules() {
    this.editorService.init();
    return {
      toolbar: {
        container: [['bold', 'italic', 'link', { redo: 'redo' }, { undo: 'undo' }]],
        handlers: {
          redo: () => {
            this.editor?.history.redo();
          },
          undo: () => {
            this.editor?.history.undo();
          }
        }
      },
      history: { delay: 2000, maxStack: 500, userOnly: true }
    };
  }

  editorCreated(editor: any) {
    this.editor = editor;
  }

  onContentChanged(event: any) {
    this.onValueChanged();
  }

  constructor(
    private editorService: QuillEditorService,
    private changeDetector: ChangeDetectorRef,
    protected userPref: UserPreferencesFacade
  ) {}

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }

  ngOnDestroy(): void {
    this.valueChanged.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterContentChecked(): void {
    if (this.format === TextFieldFormat.MultiLine && !this.showFieldAsEdit) {
      const isOverflow = this.checkOverflow(this.multilineReadonly?.nativeElement);

      if (this.isOverflow !== isOverflow) {
        this.isOverflow = isOverflow;
      }

      this.value = this.reader.getFieldValue(this.field?.systemName);
    }
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;

    if (this.format === TextFieldFormat.MultiLine && this.showFieldAsEdit) {
    }
  }

  tpOnContentUpdated(): void {
    this.hasEditorBeenInitialized = false;
    this.value = this.reader.getFieldValue(this.field?.systemName);

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }

  checkOverflow(el: any) {
    if (!el) {
      return false;
    }

    const curOverflow = el.style.overflow;

    if (!curOverflow || curOverflow === 'visible') {
      el.style.overflow = 'hidden';
    }

    const isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

    el.style.overflow = curOverflow;

    return isOverflowing;
  }

  showMultilineDialog() {
    this.showMultilineTextDialog = true;
  }

  multilineClose() {
    this.showMultilineTextDialog = false;
  }

  contentScroll(event$) {
    if (event$ && event$.target) {
      const div = event$.target;
      this.isScrolled = div.scrollTop > 0;
      return;
    }

    this.isScrolled = false;
  }
}
